class cOptionsRegistration {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;

        var elBtnSaveRegistrationOptions = $("#save-registration-options-btn");
        this.elRegistrationOptionsEditFrom = $('#registration-options-form');

        $(elBtnSaveRegistrationOptions).click(function (e) { return self.submitRegistrationOptions(this, e); });
    }
    submitRegistrationOptions(btn, e) {
        $(btn).button('loading');

        $(this.elRegistrationOptionsEditFrom).ajaxSubmit({
            url: URL_ADMIN + '/sourcesdb/updateregistration/',
            type: 'post',
            dataType: 'json',
            data: {},
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                } else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }
}



